module.exports = __webpack_public_path__ + "img/woman-purple-blue-bg-opaque.81474457.jpg";